<div class="chart-container">
    <div style="display: block; width: 100%; height: 320px;">
        <canvas #chartCanvas></canvas>
    </div>
</div>